export default __webpack_public_path__ + "static/media/meslay14.4bc90128.jpg";